import GroupsIcon from '@mui/icons-material/Groups';
import { Box } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Colors from '../../colors';
import LoadingSpinner from '../../components/LoadingSpinner';
import PlusIconButton from '../../components/PlusIconButton';
import SearchBar from '../../components/SearchBar';
import SelectableCard from '../../components/SelectableCard';
import SelectableCardContentRow from '../../components/SelectableCardContentRow';
import { getCountOfDocsInSubCollection, getDocsByCollectionAndFK } from '../../firebase';
import EncourageCreation from '../../components/EncourageCreation';

function Teams({ user, isAdmin }) {
    const [teams, setTeams] = useState([]);

    // For Search Bar
    const [search, setSearch] = useState('');
    const [searchResults, setSearchResults] = useState([]);

    // Enables Loading Spinner
    const [isLoading, setIsLoading] = useState(true);

    const navigate = useNavigate();

    const createTeam = () => {
        let path = `/createTeam`;
        navigate(path);
    };

    const editTeam = (teamId) => {
        navigate(`/teams/${teamId}`);
    };

    useEffect(() => {
        if (!user) return;

        const fetchTeams = async () => {
            try {
                const userId = user.uid;
                const teamsDocs = await getDocsByCollectionAndFK('Teams', 'userId', userId);
                const teamsArray = [];

                for (const doc of teamsDocs) {
                    const membersCount = await getCountOfDocsInSubCollection('Teams', doc.id, 'Members');
                    const teamId = doc.id;
                    const teamName = doc.name;
                    const teamIcon = <GroupsIcon sx={{ color: Colors.blue }} />;

                    const newTeam = {
                        id: teamId,
                        name: teamName,
                        infoRows: [
                            <SelectableCardContentRow
                                key={'TEAM NAME'}
                                iconComponent={teamIcon}
                                title={teamName}
                                mainText={`${membersCount} Members`} />
                        ]
                    }
                    teamsArray.push(newTeam);

                }
                setTeams(teamsArray);
            } catch (error) {
                console.error(error);
            }
            setIsLoading(false);
        }
        fetchTeams();
    }, [user, isAdmin]);

    // Use effect for filtering displayed rows by search
    useEffect(() => {
        setSearchResults([]);
        if (search.length > 0) {
            setSearchResults(teams.filter((team) => {
                return (
                    team
                        .name
                        .toLowerCase()
                        .includes(search.toLowerCase())
                );
            }));
        }
    }, [search, teams]);

    const noFoundStyles = {
        marginTop: '16px'
    };

    function displayTeams() {
        let displayedTeams;
        if (searchResults.length === 0 && teams.length === 0) {
            displayedTeams = <div style={noFoundStyles}><EncourageCreation headerText={'(0) Teams found.'} suggestionText={'Tap the plus icon to get started!'} /></div>;
        } else if (search.length === 0 && teams.length > 0) {
            displayedTeams = teams
                .map(team => (<SelectableCard
                    key={team.id}
                    title={team.title}
                    infoRows={team.infoRows}
                    onClickHandler={() => editTeam(team.id)} />));
        } else if (searchResults.length === 0 && teams.length > 0) {
            displayedTeams = <div style={noFoundStyles}><EncourageCreation headerText={'(0) Teams found.'} suggestionText={'No Team names match your search.'} /></div>;
        } else {
            displayedTeams = searchResults
                .map(team => (<SelectableCard
                    key={team.id}
                    title={team.title}
                    infoRows={team.infoRows}
                    onClickHandler={() => editTeam(team.id)} />));;
        }
        return displayedTeams;
    }

    return (
        <div>
            {isLoading && <LoadingSpinner isLoading={isLoading} />}
            <div style={{
                textAlign: 'center',
                paddingTop: '2rem'
            }}>
                <SearchBar
                    placeholder={'Search Team'}
                    search={search}
                    setSearch={setSearch} />
            </div>
            {displayTeams()}
            <Box
                sx={{ position: 'fixed', bottom: '20px', right: '20px' }} >
                <PlusIconButton color={Colors.green} onClick={createTeam} />
            </Box>
        </div>
    )
};

export default Teams;